<template>
    <div class="relative cursor-pointer w-full mr-1" ref="dropdown">
        <div class="w-full flex items-center truncate"
            @click="toggleDropdown" :style="{'background-color': theme}"
            :class="{ 'ds-field-trigger px-3': !md, 'h-[64px] rounded bg-grayxlight pl-3 pr-3 text-xl text-gray': md, 'opacity-50 cursor-not-allowed': disabled,
        'pointer-events-none': disabled}"> 
            <slot></slot>
        </div>
        <icon v-if="theme === 'white'" class="absolute right-2 top-0" @click="toggleDropdown"><IconDropdown /></icon>
        <div v-if="isOpen"
            class="ds-dropdown-menu absolute left-0 right-0 overflow-y-auto z-10 max-h-52"
            v-click-outside="toggleDropdown"  :class="{ 'open-bottom': openDown,  'open-top': !openDown}">
            <div v-if="search" class="p-2">
                <base-input v-model="searchText" placeholder="Поиск"></base-input>
            </div>
            <div v-for="option in options" :key="option.id" class="ds-dropdown-option"
                @click="selectOption(option)">
                <span class="ds-dropdown-option-label" :class="{ 'ds-dropdown-option-selected': selected?.id === option.id }">{{ option.name
                    }}</span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref,  useTemplateRef, computed, watch } from 'vue'
import { Option } from '../types'
import IconDropdown from './icons/IconDropdown.vue'

interface Props {
    options: Option[],
    theme?: string,
    size?: string,
    search?: boolean,
    direction?: 'up' | 'down' | 'calc',
    disabled?: boolean
}

const { options, size, search, direction, disabled } = defineProps<Props>()
const selected = defineModel<Option>()
const dropdown = useTemplateRef('dropdown')
const searchText = ref('')

const emit = defineEmits(['selected', 'onsearch'])

const md = computed(() => size === 'md')

const isOpen = ref(false)
const openDown = ref(true)

const toggleDropdown = () => {
    if(disabled) return
    isOpen.value = !isOpen.value
    if(direction === 'up') openDown.value = false
    else if(direction === 'down') openDown.value = true
    else {
        // open up or down depending on position
        if(dropdown.value?.getBoundingClientRect().y && (window.innerHeight - dropdown.value?.getBoundingClientRect().y) < options.length*40) {
            openDown.value = false
        } else {openDown.value = true}
    }
};

const selectOption = (option: Option) => {
    selected.value = option
    isOpen.value = false
    emit('selected')
};

watch(searchText, () => emit('onsearch', searchText.value))
</script>

<style scoped>
.selected {
    border-color: #211A4D;  
    position: relative;
}
.open-bottom {
        top: 100%
    }
.open-top {
        bottom: 100%
    }
</style>
